import { cva } from "class-variance-authority";

export const variantes = cva(
  "text-[var(--foreground)] inline-flex items-center justify-center rounded-md text-sm font-bold disabled:pointer-events-none disabled:opacity-50 cursor-pointer gap-2 whitespace-nowrap shrink-0 transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 outline-none focus-visible:border-[var(--ring)] focus-visible:ring-[var(--ring)]/50 focus-visible:ring-[3px] aria-invalid:border-[var(--destructive)] aria-invalid:ring-[var(--destructive)]/20 hover:brightness-110 shadow-lg shadow-black/30",
  {
    variants: {
      variant: {
        default: "bg-[var(--primary)] text-[var(--background)] ",
        danger:
          "bg-[var(--destructive)] focus-visible:ring-[var(--destructive)]/20",
        outline: "border bg-transparent",
        primary: "bg-[var(--primary)] text-[var(--background)]",
        secondary: "bg-[var(--secondary)] text-[var(--secondary-foreground)]",
        link: "text-[var(--primary)] underline-offset-4 hover:underline",
        headerAction: "bg-[var(--primary)] text-[var(--background)]",
        icon: "bg-transparent shadow-none",
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "h-auto w-auto rounded-full p-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
